const COMMON_ICONS = [
  'check-circle',
  'x-circle',
  'alert-triangle',
  'alert-circle',
  'info',
  'search',
  'user',
  'home',
  'settings',
  'menu',
  'chevron-down',
  'chevron-up',
  'chevron-left',
  'chevron-right',
  'plus',
  'minus',
  'x',
  'loader'
];

export const iconCache = new Map<string, string>();
export const loadingPromises = new Map<string, Promise<string>>();

export const preloadCommonIcons = async () => {
  const icons = import.meta.glob('/src/assets/icons/*.svg', { query: '?raw', import: 'default' });
  
  const preloadPromises = COMMON_ICONS.map(async (iconName) => {
    if (iconCache.has(iconName)) return;
    
    const iconPath = `/src/assets/icons/${iconName}.svg`;
    if (!icons[iconPath]) return;
    
    try {
      const svg = (await icons[iconPath]()) as string;
      iconCache.set(iconName, svg);
    } catch (error) {
      console.warn(`Failed to preload icon: ${iconName}`, error);
    }
  });
  
  await Promise.all(preloadPromises);
  console.log(`Preloaded ${COMMON_ICONS.length} common icons`);
};

export { iconCache as default };
